<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="padding-top:150px;">‘Do you intend to undertake a Grand Tour of Europe, Banks?’</p>
<p style="text-indent:01em !important;">‘Every blockhead does that; my Grand Tour shall be one around the whole globe!’</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?15e887df